import { ReactElement, useEffect, useState } from "react";
import { ColumnsType } from "antd/es/table";
import { Tooltip } from "antd";

import "./states.scss";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import CustomTable from "../../components/custom-table/custom-table";
import { useDispatch, useSelector } from "react-redux";
import { LOADING } from "../../store/actions";
import instance from "../../store/axios";
import { AxiosResponse } from "axios";
import CustomSearch from "../../components/custom-search/custom-search";
import { Link, useParams } from "react-router-dom";
import toast from "react-hot-toast";

const States: React.FC = (): ReactElement => {
  const dispatch = useDispatch();
  const { countryId } = useParams();
  const user = useSelector((state: any) => state.user);
  const [statesData, setStatesData] = useState([]);

  useEffect(() => {
    getStatesData();
  }, []);

  const getStatesData = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/option/${countryId}/states`
      );
      setStatesData(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/countries`);
    }

    dispatch({ type: LOADING, payload: false });
  };

  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Name En",
      dataIndex: "nameEn",
      key: "nameEn",
      sorter: (a, b) => a.nameEn.length - b.nameEn.length,
      fixed: "left",
      render: (text, record) =>
        user?.permissions.includes("view_cities") ? (
          <Link to={`/cities/${record.id}`}>{text}</Link>
        ) : (
          <span>{text}</span>
        ),
    },
    {
      title: "Name Ar",
      dataIndex: "nameAr",
      key: "nameAr",
      sorter: (a, b) => a.nameAr.length - b.nameAr.length,
    },
    {
      title: "Order",
      dataIndex: "order",
      key: "order",
      sorter: (a, b) => a.order.length - b.order.length,
    },
  ];

  return (
    <section className="states-container flex column">
      <div className="flex align-center justify-space-between">
        <BreadcrumbComponent />
      </div>

      <div className="states-table">
        <div className="title flex align-center justify-space-between">
          <p>{statesData?.length} States</p>
          <div className="images flex align-center">
            <CustomSearch />
            <Tooltip placement="topLeft" title="Columns settings">
              <img src={"/images/grid.svg"} alt="grid" />
            </Tooltip>
            <Tooltip placement="topLeft" title="Export">
              <img src={"/images/export.svg"} alt="export-customers" />
            </Tooltip>
            <Tooltip placement="topLeft" title="Upload">
              <img src={"/images/upload.svg"} alt="upload-customers" />
            </Tooltip>
          </div>
        </div>
        <CustomTable columns={columns} data={statesData} showPagination={false} />
      </div>
    </section>
  );
};

export default States;
